<template>
  <div color="error-body">
    <template v-if="showErrors()">
      <div
        class="mandotry-color"
        v-for="(error, index) in listOfErrors()"
        :key="index"
      >
        {{ error }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ShowErrors",
  data() {
    return {
      reg: /^[a-zA-Z0-9.]+@[a-zA-Z0-9-]+\.[a-zA-Z]+/,
      errorMessages: {
        required: () => this.fieldName(),
        decimal: params => this.DECIMAL,
        numeric: params => this.NUMERIC,
        email: params => this.email(),
        float: params => this.FLOAT,
        minLength: params => this.minValue(),
        sameAsPassword: params => this.SAMEPASSWORD,
        specialPassword: params => this.SPECIALPASSWORD,
        phoneNumber: params => this.phoneNumberval(),
        phonevalidation : params => this.PHONEVALIDATION,
        postalCodeRegex: params => this.postalCode(),
        vrIdRegex: params => this.vrId(),
        emailRegexForCreateUserInfo: params => this.emailForCreateUserInfo()
      },
      REQUIREDFIELD: "",
      canShowError: false,
      DECIMAL: "",
      NUMERIC: "",
      PLEASEPROVIDE: "",
      EMAIL: "",
      FLOAT: "",
      VALIDPASSWORD: "",
      SAMEPASSWORD: "",
      SPECIALPASSWORD: "",
      PHONEVALIDATION: ""
    };
  },
  props: {
    control: {
      type: [Array, Object],
      default: () => {}
    },
    field: {
      type: String,
      default: ""
    }
  },
  computed: {},
  methods: {
    fieldName() {
      if (this.field) {
        if (this.$i18n.locale == "ja") {
          // return this.field + this.PLEASEPROVIDE;
          return this.field;
        }
        // return this.PLEASEPROVIDE + " " + this.field;
        return this.PLEASEPROVIDE;
      }
      return this.REQUIREDFIELD;
    },

    email: function() {
      return this.email == ""
        ? ""
        : this.reg.test(this.email)
        ? "has-success"
        : this.$t("INVALIDEMAIL");
    },
    emailForCreateUserInfo() {
      return this.$t("INVALIDEMAIL");
    },
    getMessage(type, params) {
      return this.errorMessages[type](params);
    },
    minValue() {
      if (this.control.$model.length < this.control.$params.minLength.min) {
        console.log("sss", this.control.$params);
        return this.control.$params.minLength.min + this.RANGENOTE1;
      }
    },
    postalCode() {
      return this.$t("INVALID_POSTAL_CODE");
    },
    vrId() {
      return this.$t("INVALID_PATIENT_VR_ID");
    },
    phoneNumberval() {
      if (this.control.$model.length < this.control.$params.phoneNumber.min) {
        return this.PHONEVALIDATION;
      }
    },

    showErrors() {
      if(this.control){
         return (
          this.control.$invalid && this.control.$anyError && this.control.$dirty
        );
      }

    },
    listOfErrors() {
      const params = this.control.$params;
      return Object.keys(params).map(field => {
        if (!this.control[field]) {
          return this.getMessage(field, params);
        }
      });
    }
  },
  mounted() {
    this.REQUIREDFIELD = this.$t("REQUIREDFIELD");
    this.DECIMAL = this.$t("DECIMAL");
    this.NUMERIC = this.$t("NUMERIC");
    this.PLEASEPROVIDE = this.$t("PLEASEPROVIDE");
    this.EMAIL = this.$t("INVALIDEMAIL");
    this.FLOAT = this.$t("DECIMAL");
    this.VALIDPASSWORD = this.$t("VALIDPASSWORD");
    this.SAMEPASSWORD = this.$t("SAMEPASSWORD");
    this.SPECIALPASSWORD = this.$t("SPECIALPASSWORD");
    this.RANGENOTE1 = this.$t("RANGENOTE1");
    this.RANGENOTE2 = this.$t("RANGENOTE2");
    this.PHONEVALIDATION = this.$t("PHONEVALIDATION");
  }
};
</script>
<style>
.ererror-bodyr{
  float: left;
}
</style>
